function statusGroupFromStn(str: string){
    const statusGroup = {
        "safety": "SG001",
        "caution": "SG002",
        "warning": "SG003",
        "inspection": "SG004"
    }
    return statusGroup[str] ?? "SG004";
}

function statusFromStn(str: string){
    str = str.toString();
    const status = {
        "-1": "점검",
        "0": "안전운행",
        "1": "폭염주의",
        "2": "폭염경보",
        "3": "강풍주의",
        "4": "강풍경보",
        "5": "미끄럼주의",
        "6": "미끄럼경보",
        "7": "살얼음주의",
        "8": "살얼음경보",
        "9": "눈 감지"
    }
    return status[str] ?? "점검";
}

function statusGroupFromStatus(status: string){
    const statusGroup = new Map();
    statusGroup.set("안전운행", "안전");
    statusGroup.set("폭염주의", "주의");
    statusGroup.set("폭염경보", "경보");
    statusGroup.set("강풍주의", "주의");
    statusGroup.set("강풍경보", "경보");
    statusGroup.set("미끄럼주의", "주의");
    statusGroup.set("미끄럼경보", "경보");
    statusGroup.set("살얼음주의", "주의");
    statusGroup.set("살얼음경보", "경보");
    statusGroup.set("눈 감지", "경보");
    statusGroup.set("점검", "점검");
    return statusGroup.get(status) ?? "점검";
}
export { statusGroupFromStn, statusFromStn, statusGroupFromStatus };